import type { CustomCellRendererProps } from "ag-grid-react";
import { clsx } from "clsx";
import { ColoredLabel, TruncateText } from "widgets";
import { getCssColor } from "widgets/utils";

import style from "../styles/Cell.module.css";

export const ColoredLabelCell = (props: CustomCellRendererProps) => {
  const { value, color, label } = (props.value ?? {}) as { value?: unknown; color?: unknown; label?: unknown };
  const labelText = String(value ?? label ?? props.valueFormatted ?? "");
  const cssColor = getCssColor(typeof color === "string" ? color : undefined);

  return (
    <div className={clsx(style.cell, style.truncate_container)}>
      <span className={style.truncate_autosize} aria-hidden>{labelText}</span>
      <ColoredLabel color={cssColor} className={style.truncate_content} style={{ minWidth: 0, maxWidth: "100%" }}>
        <TruncateText text={labelText} style={{ flex: 1, minWidth: 0 }} />
      </ColoredLabel>
    </div>
  );
};
